import { faGear } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { LOCALSTORAGE_KEYS } from 'src/utils/constants';

import ConfirmationMessage from './ConfirmationMessage';

const ConfirmAutoDocumentParsingPanel = ({ onConfirm, onCancel }) => {
  const [rememberChoice, setRememberChoice] = React.useState(false);

  const onConfirmParserOption = () => {
    if (rememberChoice) {
      localStorage.setItem(LOCALSTORAGE_KEYS.AUTO_PARSE_TEMPLATE, 'parse');
    }
    onConfirm();
  };

  const onCancelParserOption = () => {
    if (rememberChoice) {
      localStorage.setItem(LOCALSTORAGE_KEYS.AUTO_PARSE_TEMPLATE, 'skip');
    }
    onCancel();
  };

  return (
    <div className='dp-confirm-container'>
      <ConfirmationMessage
        title='Auto-parse this document?'
        subtitle='We’ll use the attached template to fill fields for you.'
      />

      <div className='dp-actions'>
        <button
          type='button'
          className='btn btn-lg btn-primary action-btn btn-block mt25'
          onClick={onConfirmParserOption}
        >
          <p className='d-flex align-items-center justify-content-center mb0'>Yes</p>
        </button>

        <button type='button' className='btn btn-lg btn-block' onClick={onCancelParserOption}>
          No
        </button>
      </div>

      <div className='dp-info-block mt10'>
        <div className='setting-item'>
          <label className='toggle-label'>
            <span>Save this option and don&apos;t ask again</span>
            <input
              type='checkbox'
              className='toggle-input'
              checked={rememberChoice}
              onChange={e => setRememberChoice(e.target.checked)}
            />
            <span className='toggle-slider' />
          </label>
        </div>

        <div className='dp-info-footer'>
          <FontAwesomeIcon icon={faInfoCircle} />
          <span>You can always change this option in</span>
          <span className='dp-mobile-break' />
          <span className='dp-link'>
            <FontAwesomeIcon icon={faGear} /> About Page
          </span>
        </div>
      </div>
    </div>
  );
};

ConfirmAutoDocumentParsingPanel.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmAutoDocumentParsingPanel;
